<template lang="pug">
    .component-card-7
        .row
            .columns.shrink.align-self-middle(v-if="showBullets")
                slot(name="actionBullets")
            .columns
                .row
                    .columns(v-for="n in 7", :class="{'shrink': shouldShrink('n'+n)}").align-self-middle
                        slot(:name="'n'+n")
            .columns.shrink.align-self-middle(v-if="showAction")
                slot(name="actionPage")

</template>
<script type="text/babel">
    export default {
        name: "Card7",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {
            actionClicked() {
                this.$emit('actionClicked')
            },
            bulletsClicked() {
                this.$emit('bulletsClicked')
            },
            shouldShrink(slot) {

                var t = false;
                if (this.shrink) {

                    this.shrink.forEach((item) => {

                        if (item[slot]) {
                            t = true
                        }
                    });
                }

                return t
            }
        },
        computed: {},
        props: ['showBullets', 'showAction', 'shrink']
    }
</script>

<style lang="sass" rel="stylesheet/sass">
    .action
        cursor: pointer
</style>



// WEBPACK FOOTER //
// Card7.vue?4b1b2c44